module.exports = __webpack_public_path__ + "img/nav_icon_modeling_normal.ba7c63c2.png";